import structuredClonePolyfill from '@ungap/structured-clone';

if (typeof globalThis.structuredClone !== 'function') {
  globalThis.structuredClone =
    structuredClonePolyfill as typeof globalThis.structuredClone;
}

if (typeof Array.prototype.toReversed !== 'function') {
  Object.defineProperty(Array.prototype, 'toReversed', {
    configurable: true,
    writable: true,
    value: function toReversed<T>(this: T[]): T[] {
      return Array.prototype.slice.call(this).reverse();
    },
  });
}
